module.exports = "<button ng-click=\"onClick()\" ng-class=\"{'gw-btn-primary': primary, 'gw-btn': !primary}\">\n    <ng-transclude></ng-transclude>\n</button>"


//////////////////
// WEBPACK FOOTER
// ../common/grunt/webpack/loaders/text-loader!../common/js/src/edge/platform/atomic_design/button/button.html
// module id = 449
// module chunks = 0